module.exports = "/assets/data/3440d19a637c465984e29cb26b97117b-WF2.data.json";